/* eslint-disable */
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import './Tabs.css';

const Tabs = ({ tabs, selected, currentTab }: any) => {
  const [activeTab, setActiveTab] = useState(selected);
  useEffect(() => {
    if (currentTab) {
      currentTab(activeTab);
    }
  }, [activeTab, selected]);
  return (
    <div className="scrollable-tabs">
      <div className="hidden-scrollbar tabs-container">
        <div className="new-tabs">
          {tabs.map(
            (tab: any, index: number) =>
              !tab.hidden && (
                <div
                  onClick={() => setActiveTab(tab.key)}
                  key={index}
                  className={classnames(
                    'tab',
                    activeTab === tab.key ? 'active' : ''
                  )}
                >
                  {tab.value}
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
